/**
 * Appraisal routes. Mounted under /hr.
 */
export const appraisalRoutes: any[] = [
  {
    // Now the full form - key result areas, the six competencies, the
    // development plan and the five-stage chain. This supersedes MyAppraisal.vue,
    // which showed goals against the older six-stage moderation flow and had no
    // competencies or development plan. That file is no longer routed and can be
    // deleted once this has been signed off.
    path: 'performancemanagement/my-appraisal',
    name: 'myAppraisal',
    component: () => import('@/modules/hr/performancemanagement/appraisal/components/AppraisalForm.vue'),
    meta: { title: 'routes.myAppraisal', requiresAuth: true, breadcrumb: 'My Appraisal' },
  },
  {
    // The same form opened for someone else, by whoever the chain routes it to.
    path: 'performancemanagement/appraisal-form/:employeeId',
    name: 'appraisalForm',
    component: () => import('@/modules/hr/performancemanagement/appraisal/components/AppraisalForm.vue'),
    meta: { title: 'routes.appraisalForm', requiresAuth: true, breadcrumb: 'Appraisal' },
  },
  {
    path: 'performancemanagement/appraisal-inbox',
    name: 'appraisalInbox',
    component: () => import('@/modules/hr/performancemanagement/appraisal/components/AppraisalInbox.vue'),
    meta: { title: 'routes.appraisalInbox', requiresAuth: true, breadcrumb: 'Appraisals' },
  },
  {
    // The reusable KRAs a role is appraised against. Before this, every
    // appraisal started from an empty form and the goals were retyped per
    // employee — so two people in the same role were not comparable.
    path: 'performancemanagement/kra-library',
    name: 'kraLibrary',
    component: () => import('@/modules/hr/performancemanagement/appraisal/components/KRALibrary.vue'),
    meta: { title: 'Key Result Areas', requiresAuth: true, breadcrumb: 'Key Result Areas' },
  },
  {
    path: 'performancemanagement/appraisal',
    name: 'appraisalCycles',
    component: () => import('@/modules/hr/performancemanagement/appraisal/components/AppraisalCycleList.vue'),
    meta: { title: 'routes.appraisalCycles', requiresAuth: true, breadcrumb: 'Appraisal Cycles' },
  },
  {
    path: 'performancemanagement/appraisal/:id',
    name: 'appraisalModeration',
    component: () => import('@/modules/hr/performancemanagement/appraisal/components/AppraisalModeration.vue'),
    meta: { title: 'routes.appraisalModeration', requiresAuth: true, breadcrumb: 'Cycle' },
  },
]

export default appraisalRoutes
